<div mat-dialog-content class="body">
  <div class="body__title">You’re deleting the delivery method {{ checkoutName }}.</div>
  <div class="body__text">Are you sure?</div>
</div>
<div mat-dialog-actions class="body__actions">
  <button class="body__button__cancel" (click)="onCancel()">Cancel</button>
  <button mat-flat-button class="body__button__apply" (click)="onDeleteCheckout()">Delete</button>
</div>
